import { BotFormContext } from "@shared/features/bots/BotForm/common/BotForm.context";
import React, { PropsWithChildren, useContext } from "react";
import useBulkCreateBotsForm from "@shared/features/bots/BotForm/common/hooks/useBulkCreateBotsForm";

const BulkCreateBotsValuesProvider = ({ children }: PropsWithChildren) => {
  const botFormContextValues = useContext(BotFormContext)!;
  const bulkCreateBotsFormData = useBulkCreateBotsForm();

  return (
    <BotFormContext.Provider
      value={{
        ...botFormContextValues,
        ...bulkCreateBotsFormData,
      }}
    >
      {children}
    </BotFormContext.Provider>
  );
};

export default BulkCreateBotsValuesProvider;
